import api from "./client";

// Persona API — manual getToken checks removed; the axios interceptor handles auth.
export const personaAPI = {
  // Get all personas
  getAllPersonas: async (clientId) => {
    try {
      const response = await api.get("/api/v1/personas", {
        params: { client_id: clientId },
      });
      return response.data;
    } catch (error) {
      if (error.response?.status === 401) {
        if (error.response?.data?.error === "Token has been revoked") {
          throw new Error(
            "Your session has been revoked. Please log in again."
          );
        } else if (error.response?.data?.error === "Token expired") {
          throw new Error("Your session has expired. Please log in again.");
        }
        throw new Error("Authentication failed. Please log in again.");
      }
      console.error("Error fetching personas:", error);
      throw error;
    }
  },

  // Get a single persona by ID
  getPersona: async (id, clientId) => {
    try {
      const response = await api.get(`/api/v1/personas/${id}`, {
        params: { client_id: clientId },
      });
      return response.data;
    } catch (error) {
      if (error.response?.status === 401) {
        throw new Error("Please log in to view persona details");
      } else if (error.response?.status === 404) {
        throw new Error("Persona not found");
      }
      console.error(`Error fetching persona ${id}:`, error);
      throw error;
    }
  },

  // Create a new persona
  createPersona: async (personaData, clientId) => {
    try {
      const response = await api.post(
        "/api/v1/personas",
        { persona: personaData },
        {
          params: { client_id: clientId },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response?.status === 401) {
        throw new Error("Please log in to create a persona");
      } else if (error.response?.status === 422) {
        throw new Error(error.response.data?.error || "Invalid persona data");
      }
      console.error("Error creating persona:", error);
      throw error;
    }
  },

  // Update an existing persona
  updatePersona: async (id, personaData, clientId) => {
    try {
      const response = await api.put(
        `/api/v1/personas/${id}`,
        { persona: personaData },
        {
          params: { client_id: clientId },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response?.status === 401) {
        throw new Error("Please log in to update a persona");
      } else if (error.response?.status === 404) {
        throw new Error("Persona not found");
      } else if (error.response?.status === 422) {
        throw new Error(error.response.data?.error || "Invalid persona data");
      }
      console.error(`Error updating persona ${id}:`, error);
      throw error;
    }
  },

  // Delete a persona
  deletePersona: async (id, clientId) => {
    try {
      const response = await api.delete(`/api/v1/personas/${id}`, {
        params: { client_id: clientId },
      });
      return response.data;
    } catch (error) {
      if (error.response?.status === 401) {
        throw new Error("Please log in to delete a persona");
      } else if (error.response?.status === 404) {
        throw new Error("Persona not found");
      }
      console.error(`Error deleting persona ${id}:`, error);
      throw error;
    }
  },

  // Toggle persona enabled state
  togglePersona: async (id, clientId) => {
    try {
      const response = await api.post(`/api/v1/personas/${id}/toggle`, {
        params: { client_id: clientId },
      });
      return response.data;
    } catch (error) {
      if (error.response?.status === 401) {
        throw new Error("Please log in to toggle a persona");
      } else if (error.response?.status === 404) {
        throw new Error("Persona not found");
      }
      console.error(`Error toggling persona ${id}:`, error);
      throw error;
    }
  },

  // Start an ephemeral "talk to persona" LiveKit preview. Returns
  // { room_url, token, room_name } for the browser to join.
  startPreview: async (id, clientId) => {
    const response = await api.post(`/api/v1/personas/${id}/preview`, null, {
      params: { client_id: clientId },
    });
    return response.data;
  },
};
